/**
 * API Configuration
 *
 * Centralized env-aware API + Socket URLs.
 * - If running on localhost, default to local backend (http://localhost:5000)
 * - Else, default to production backend
 * - Always respect REACT_APP_API_URL / REACT_APP_SOCKET_URL if provided
 */

const hostname = window.location.hostname || "";

// Detect if running locally
const isLocal =
  hostname.includes("localhost") ||
  hostname.startsWith("127.") ||
  hostname.startsWith("192.168.");

// Environment variables (if defined by build/runtime)
const REACT_APP_API_URL = process.env.REACT_APP_API_URL;
const REACT_APP_SOCKET_URL = process.env.REACT_APP_SOCKET_URL;

// Defaults
const PROD_API_URL = "https://backend.cabzigo.com/api";
const PROD_SOCKET_URL = "https://backend.cabzigo.com";
const PROD_BASE_URL = "https://backend.cabzigo.com";

const DEV_API_URL = "http://localhost:5000/api";
const DEV_SOCKET_URL = "http://localhost:5000";
const DEV_BASE_URL = "http://localhost:5000";

// FORCE_PRODUCTION = true to always use production backend
// If hostname is cabzigo.com, we are definitely in production
const IS_PRODUCTION_DOMAIN = hostname === "cabzigo.com" || hostname === "www.cabzigo.com";
const FORCE_PRODUCTION = IS_PRODUCTION_DOMAIN;

// Resolve URLs - use env vars first, then force production if flag set, then local detection
let API_URL = REACT_APP_API_URL || (FORCE_PRODUCTION ? PROD_API_URL : (isLocal ? DEV_API_URL : PROD_API_URL));
let BASE_URL = FORCE_PRODUCTION ? PROD_BASE_URL : (isLocal ? DEV_BASE_URL : PROD_BASE_URL);
let SOCKET_URL = REACT_APP_SOCKET_URL || (FORCE_PRODUCTION ? PROD_SOCKET_URL : (isLocal ? DEV_SOCKET_URL : PROD_SOCKET_URL));

// Sanitize SOCKET_URL: remove accidental ":0" port and ensure origin-only (no trailing slash)
try {
  const parsed = new URL(SOCKET_URL);
  if (parsed.port === "0") parsed.port = ""; // remove port 0 if present
  
  // Clean up any trailing slashes or /socket.io from the URL
  SOCKET_URL = parsed.origin;
} catch (e) {
  // If URL parsing fails, keep the original value
  console.warn('apiConfig: failed to parse SOCKET_URL for sanitization', e && e.message);
}

// DEBUG: Log the actual values to help troubleshooting
if (process.env.NODE_ENV === "development" || isLocal) {
  console.log('[apiConfig] Hostname:', hostname);
  console.log('[apiConfig] isLocal:', isLocal);
  console.log('[apiConfig] IS_PRODUCTION_DOMAIN:', IS_PRODUCTION_DOMAIN);
  console.log('[apiConfig] SOCKET_URL:', SOCKET_URL);
  console.log('[apiConfig] API_URL:', API_URL);
}

// Fallback production API URL (kept for compatibility)
const FALLBACK_API_URL = "https://backend.cabzigo.com/api";

export { API_URL, BASE_URL, SOCKET_URL, FALLBACK_API_URL };
